module.exports = __webpack_public_path__ + "img/icon_blue-big_car.3b3844fe.svg";